import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { updateProfileApi } from "../../Services/updateProfile/updateProfileApi";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { CommunityOwner, SuperAdmin, HomeOwner } from "../../Utils/Constant";
import "react-toastify/dist/ReactToastify.css";
// import defaultProfilePic from '../../images/woman-profile-pic.jpg';
import defaultProfilePic from "../../images/default_pfp.svg";
import "./updateProfile.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function UpdateProfile() {
  const [errors, setErrors] = useState({});
  const [filename, setFilename] = useState({});
  const [profilePic, setProfilePic] = useState(defaultProfilePic); // Default image path
  const [imageFile, setImageFile] = useState(null); // To store the uploaded file
  const [isClicked, setIsClicked] = useState(false); // State to track click status
  
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    image: null,
  });
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const profileData = location.state?.profileData || {};

  const userType = localStorage.getItem("user_type");

  // Prefill the form with profileData when the component mounts
  useEffect(() => {
    if (profileData) {
      setFormData({
        firstName: profileData.first_name || "",
        lastName: profileData.last_name || "",
        phoneNumber: profileData.phone_number || "",
        image: profileData.image || null,
      });
    }
    // setFilename(profileData.image);
  }, [profileData]);


  // Handle input changes
  const handleChange = (event) => {
    const { name, value, files } = event.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value, // Handle file inputs separately
    });
  };
  const convertUrlToFile = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], "profile.jpg", { type: blob.type });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const finaldata = new FormData();
    finaldata.append("first_name ", formData.firstName);
    finaldata.append("last_name", formData.lastName);
    finaldata.append("phone_number", formData.phoneNumber);

    // Check if the profilePic is a URL or a file
    if (profilePic.startsWith("https")) {
      try {
        const file = await convertUrlToFile(profilePic); // Define convertUrlToFile separately
        finaldata.append("image", file);
      } catch (err) {
        console.error("Error converting URL to file:", err);
      }
    } else if (imageFile instanceof File) {
      finaldata.append("image", imageFile);
    }

    dispatch(
      updateProfileApi({
        profileId: profileData.id,
        formData: finaldata,
      })
    )
      .unwrap()
      .then((res) => {
        toast.success("Profile Updated successfully!");
        if (userType === CommunityOwner) {
          setTimeout(() => {
            navigate("/admin/Admin-community");
          }, 1000);
        }
        if (userType === SuperAdmin) {
          setTimeout(() => {
            navigate("/super-admin/super-admin-community-comp");
          }, 1000);
        }
        if (userType === HomeOwner) {
          setTimeout(() => {
            navigate("/home-owner-admin/home-owner-community");
          }, 1000);
        }
      })
      .catch((err) => {
        toast.error(" Profile Updated failed!");
      });
  };

   // Function to handle the image change
  const updateProfilePic = (event) => {
    const file = event.target.files[0]; // Get the selected file
    const reader = new FileReader(); // Create a FileReader to read the file

    reader.onloadend = () => {
      setProfilePic(reader.result); // Set the profile picture state to the selected image
      setIsClicked(true); 
      setImageFile(file); 
     
    };

    if (file) {
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };

  return (
    <>
      <div className="back-btn">
        <button onClick={() => navigate(-1)} className="back-btn-button">
          {/* <img src={chevronleft} alt="chevron-left" className="left-icon" />
           */}
          <ArrowBackIcon className="left-icon" />
          Back
        </button>
      </div>
      <div className="container mt-5">
        <div className="row justify-content-center mb-5">
          <div className="col-md-8">
            <div className="card shadow-sm">
              <div className="card-body p-4">
                <h4 className="card-title text-center mb-4">Update Profile</h4>
                <div className="profile-picture-block text-center mb-5">
                  <div className="profile-pic-container">
                    <img
                      src={
                        isClicked
                          ? profilePic
                          : formData.image || defaultProfilePic // Fallback to formData.image or default pic
                      }
                      alt="Profile"
                      className="profile-pic"
                      id="profilePic"
                    />
                    <div
                      className="edit-icon"
                      onClick={() =>
                        document.getElementById("fileInput").click()
                      }
                    >
                      <i className="fa fa-pencil"></i> {/* FontAwesome icon */}
                    </div>
                    <input
                      type="file"
                      id="fileInput"
                      className="file-input"
                      accept="image/*"
                      onChange={updateProfilePic}
                    />
                  </div>
                </div>
                <form onSubmit={handleSubmit} noValidate>
                  <div className="row mb-3">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="firstName" className="form-label">
                        First Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.firstName ? "is-invalid" : ""
                        }`}
                        id="firstName"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                      />
                      <div className="invalid-feedback">{errors.firstName}</div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="lastName" className="form-label">
                        Last Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.lastName ? "is-invalid" : ""
                        }`}
                        id="lastName"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                      />
                      <div className="invalid-feedback">{errors.lastName}</div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="phoneNumber" className="form-label">
                        Phone Number<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.phoneNumber ? "is-invalid" : ""
                        }`}
                        id="phoneNumber"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                      />
                      <div className="invalid-feedback">
                        {errors.phoneNumber}
                      </div>
                    </div>
                  </div>

                  {/* <div className="mb-3">
                    <label htmlFor="fileInput" className="form-label">
                      Profile Image or Company Logo (Optional)
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      id="fileInput"
                      name="image"
                      accept="image/*"
                      onChange={handleChange}
                    />
                  </div> */}
                  {/* {filename && <div className="mt-2 file-name">{filename}</div>} */}
                  <div className="text-center profile-update">
                    <button type="submit" className="bttn-upload">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default UpdateProfile;
